import { ComponentType } from 'react';
import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { AuthUser } from '@modules/AuthModule/lib/types';
import { LDSingleKindContext } from 'launchdarkly-react-client-sdk';

export { default as useFeatureFlags } from './hooks/useFeatureFlags';
export { default as FeatureFlagProvider } from './FeatureFlagProvider/FeatureFlagProvider';
export { FeatureFlagConfigurer } from './components/FeatureFlagConfigurer';
export {
  mockFeatureFlag,
  clearFeatureFlagMocks,
} from './mocks/mockFeatureFlag';

export class FeatureFlagModule extends AppModule {
  ldProviderCallback?: (
    WrappedComponent: ComponentType<object>,
  ) => ComponentType<object>;

  // Before we set it explicitly, LaunchDarkly will use a default anonymous context:
  //
  // https://docs.launchdarkly.com/sdk/features/context-config#react-web
  //
  // This is a decent representation of that.
  ldContext: LDSingleKindContext = { kind: '', key: '' };

  override preload(): void {
    this.app.events.on('auth.signin', (user: AuthUser) => {
      this.ldContext = {
        kind: 'org',
        key: user.org.id,
      };

      this.app.logger.info('User context is', this.ldContext);
    });

    // We don't register a matching 'auth.signout' listener because after
    // signout, a user will always go through a fresh pageload, triggering
    // the 'auth.signin' handler as part of app startup.
  }

  public log(message: any, ...optionalParams: any) {
    this.app.logger.info(message, ...optionalParams);
  }
}

export default new FeatureFlagModule(
  appManager.events,
  appManager.logger('FeatureFlag'),
);
